module.exports = __webpack_public_path__ + "static/img/2-2.a9660655.png";